
    import axios, { AxiosResponse } from 'axios';
    
    import { defineComponent } from 'vue';
    import * as jQuery from 'jquery';
    import Swal from 'sweetalert2/dist/sweetalert2.js';

    export class UserInfo {
        public iduser: number = 0;
        public username: string = "";
        public isconfirmed: boolean = false;
        public email: string = "";
        public groupe: number = 0;
        public hash: string = "";
        public locale: string = "";
        public datecreation!: Date;
    }

    export class LoginResult {
        public token: string = "";
        public urlProfil: string = "";
        public isadmin: boolean = false;
        public userinfo: UserInfo | null = null;
    }

    export enum RequestState {
        Failed = -1,
        NotAuth = 0,
        Success = 1
    }

    export class RequestResult {
        public state: RequestState | null = null;
        public msg: string = "";
        public data: LoginResult | null = null;
        public versionajour: boolean = true;
    }

    export class ExternalProvider {
        public name: string = "";
        public displayname: string = "";
    }



    export class LoginModalView {
        public m_err: boolean = false;
        public loginreturnurl: string = "";
        public m_listeprovider: ExternalProvider[] = [];
    }

    export default defineComponent({
        data() {
            return {
                view: null as LoginModalView|null,
                username: "",
                password: "",
                returnurl: "",
                err: ""
            };
        },
        props: {
            dclang_mcbuttonok: String,
            dcurl_externallogin: String,
            dclang_mc_error_5: String,
            dc_descloginreferer: String,
            view_loginmodal_email: String,
            view_loginmodal_pass: String,
            view_loginmodal_creercompte: String,
            view_loginmodal_forgotpass: String,
            view_loginmodal_butconnect: String,
            view_loginmodal_oauthtitle: String,
            view_loginmodal_oauthdesc1: String,
            view_loginmodal_oauthdesc2: String,
            view_loginmodal_infos: String
        },
        methods: {
            async Login(event: any) {
                this.returnurl = jQuery("#returnurlmodal").val() as string;
                let datapost: any = {
                    mc_username: this.username,
                    mc_password: this.password,
                };
                let self = this;
                event.preventDefault();
                const response: AxiosResponse<RequestResult> = await axios.post<RequestResult>("/api/v1/login/AjaxLogin", datapost);
                if (response.data.state === 1) {

                    if (response.data.versionajour) {
                        if (self.returnurl == "") {
                            if (window.location.pathname == "" || window.location.pathname == "/") {
                                let url = new URL(window.location.href);
                                const search = url.search;
                                url = new URL(`${url.protocol}//${url.host}/cur/`);
                                const params = new URLSearchParams(search);
                                params.set('connect', '1');
                                url.search = params.toString();
                                window.location.href = url.toString();
                            }
                            else {
                                const url = new URL(window.location.href);
                                const params = new URLSearchParams(url.search);
                                params.set('connect', '1');
                                url.search = params.toString();
                                window.location.href = url.toString();
                            }
                        }
                        else {
                            const url = new URL(window.location.href);
                            const params = new URLSearchParams(url.search);
                            params.set('connect', '1');
                            url.search = params.toString();
                            window.location.href = url.toString();
                        }
                    }
                    else
                        self.MigrateAccount();

                }
                else {
                    if (self.dclang_mc_error_5 != null)
                        self.err = self.dclang_mc_error_5;
                }
            },
            NextPage(mode: number) {
                this.$emit("changemode", mode);
                return false;
            },
            MigrateAccount() {
                this.NextPage(3);
            }
        },
        async mounted() {
            let self = this;
            const response: AxiosResponse<LoginModalView> = await axios.get<LoginModalView>("/api/v1/login/loginmodal");
            if (response.data !== null) {
                self.view = response.data;
            }
        }
    });
